import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 30000 });

export const api = {
    stats: () => http.get("/stats").then((r) => r.data),
    classes: () => http.get("/classes").then((r) => r.data),
    classSubjects: (cls) => http.get(`/classes/${cls}/subjects`).then((r) => r.data),
    listLO: (params) => http.get("/lo", { params }).then((r) => r.data),
    getLO: (code) => http.get(`/lo/${encodeURIComponent(code)}`).then((r) => r.data),
    addBookmark: (code, user_id) => http.post("/bookmarks", { code, user_id }).then((r) => r.data),
    removeBookmark: (code, user_id) => http.delete("/bookmarks", { params: { code, user_id } }).then((r) => r.data),
    listBookmarks: (user_id) => http.get("/bookmarks", { params: { user_id } }).then((r) => r.data),
    logSearch: (query, user_id) => http.post("/search-log", null, { params: { query, user_id } }).then((r) => r.data),
    recentSearches: (user_id) => http.get("/recent-searches", { params: { user_id } }).then((r) => r.data),
    exportUrl: (fmt, params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return `${API}/export/${fmt}${qs ? `?${qs}` : ""}`;
    },
    uploadPdf: (file, replace = false) => {
        const fd = new FormData();
        fd.append("file", file);
        return http.post(`/admin/upload-pdf?replace=${replace}`, fd).then((r) => r.data);
    },
    reseed: () => http.post("/admin/reseed?replace=true").then((r) => r.data),
};

export function getUserId() {
    let id = localStorage.getItem("lo_user_id");
    if (!id) {
        id = "u_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
        localStorage.setItem("lo_user_id", id);
    }
    return id;
}
